import { Gift, Star, CheckCircle2, Award, Zap } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import PageHeader from "@/components/PageHeader";

const EARN = [
  { label: "Complete your profile", pts: 100, icon: CheckCircle2, to: "/profile" },
  { label: "Add a health record", pts: 50, icon: Zap, to: "/records" },
  { label: "Book your first consultation", pts: 150, icon: Award, to: "/doctors" },
  { label: "Add an emergency contact", pts: 30, icon: Star, to: "/emergency-contacts" },
];

export default function Rewards() {
  const navigate = useNavigate();
  const points = 180;

  return (
    <div className="max-w-3xl" data-testid="rewards-page">
      <PageHeader title="Trata Rewards" subtitle="Earn points, unlock perks" icon={Gift} color="#F59E0B" />

      <Card className="rounded-3xl p-6 bg-gradient-to-br from-[#F59E0B1A] to-[#F59E0B08] border-border">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 rounded-2xl bg-[#F59E0B]/20 flex items-center justify-center"><Gift className="h-8 w-8 text-[#F59E0B]" /></div>
          <div>
            <p className="text-sm text-muted-foreground">Your balance</p>
            <p className="text-3xl font-bold text-foreground">{points} <span className="text-lg font-semibold">pts</span></p>
          </div>
        </div>
        <div className="mt-4">
          <div className="flex justify-between text-xs text-muted-foreground mb-1"><span>Silver</span><span>{500 - points} pts to Gold</span></div>
          <div className="h-2 rounded-full bg-muted overflow-hidden"><div className="h-full bg-[#F59E0B] rounded-full" style={{ width: `${(points / 500) * 100}%` }} /></div>
        </div>
      </Card>

      <h2 className="text-lg font-semibold mt-6 mb-3">Ways to earn</h2>
      <Card className="rounded-2xl divide-y divide-border overflow-hidden border-border">
        {EARN.map((e) => {
          const EIcon = e.icon;
          return (
            <button key={e.label} onClick={() => navigate(e.to)} className="w-full flex items-center gap-3 p-4 hover:bg-accent transition-colors text-left" data-testid={`reward-${e.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <div className="h-10 w-10 rounded-xl bg-[#F59E0B]/10 flex items-center justify-center shrink-0"><EIcon className="h-5 w-5 text-[#F59E0B]" /></div>
              <span className="flex-1 text-sm font-medium">{e.label}</span>
              <span className="text-sm font-bold text-[#F59E0B]">+{e.pts}</span>
            </button>
          );
        })}
      </Card>
      <p className="text-xs text-muted-foreground mt-4 text-center">Redeem points for consultation discounts & lab test offers (coming soon).</p>
    </div>
  );
}
